module.exports = __webpack_public_path__ + "img/webeditor-technical-2.cd738fca.png";